// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"vaps-feature-car-care_mainSection__YWPvZ"};